import script from "./organization.vue?vue&type=script&setup=true&lang=js"
export * from "./organization.vue?vue&type=script&setup=true&lang=js"

import "./organization.vue?vue&type=style&index=0&id=4e9abf9a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e9abf9a"]])

export default __exports__